module.exports = __webpack_public_path__ + "img/ic_idiom_default.b9fca2ce.png";